import { SvgGraphics } from '@tencent/alloy-renderer';
import { DrawAttrs } from '@tencent/chart/lib/antv/g2/interface';
import { DisplayRule, generateEffectFilters, IFillStyle, IStrokeStyle } from '@tencent/alloy-graphics';
import { FORBID_WEBGL_FILTER } from '@src/slide/infrastructure/module/dependent/config/renderer/switch';
import { isEmpty } from './common';

export const DefaultDisplayOptions = {
    shadow: DisplayRule.Both,
    glow: DisplayRule.Both,
    softEdge: DisplayRule.Both,
    reflection: DisplayRule.Both,
    image: DisplayRule.Both,
};
/**
 * 自定义渲染，设置元素效果样式。
 * 使用透传原始数据渲染
 * @param graphics
 * @param drawAttrs
 */
export function setCustomFilterStyle(graphics: SvgGraphics, drawAttrs: DrawAttrs) {
    if (!shouldRenderEffects(drawAttrs)) return;

    const element = graphics;
    const { fillStyle, effects } = drawAttrs.customStyles || { };

    const filters = generateEffectFilters(effects, {
        forbidWebgl: FORBID_WEBGL_FILTER,
        isPicture: !!(fillStyle as IFillStyle)?.imageFill,
        filterDisplayOptions: DefaultDisplayOptions,
    });

    // 清空原来特效，并添加新特效
    element.filters = [];
    filters.forEach((filter) => {
        element.addFilter(filter);
    });
}

/**
 * 检查是否需要渲染特效
 * @param drawAttrs
 */
function shouldRenderEffects(drawAttrs: DrawAttrs): boolean {
    const { strokeStyle, fillStyle, effects } = drawAttrs.customStyles || { };
    if (isEmpty(effects)) return false;
    if (isEmpty(strokeStyle) && isEmpty(fillStyle)) return false;  // 无边框并且无背景，不显示特效
    const hasStroke = !isEmpty(strokeStyle) && ((strokeStyle as IStrokeStyle).fillStyle
        && !(strokeStyle as IStrokeStyle).fillStyle.noFill);
    const hasFill = !isEmpty(fillStyle) && !(fillStyle as IFillStyle).noFill;
    if (!hasFill && !hasStroke) return false; // 无边框并且无背景，不显示特效

    return true;
}
